/**
 * A WebP as a JPEG. An upload also heads the emails a company signs, and Outlook shows no WebP; a transparent
 * area turns white, as the page behind the picture would be.
 */
const webpAsJpeg = async (file: Blob): Promise<Blob> => {
  if (file.type !== 'image/webp') return file
  const bitmap = await createImageBitmap(file).catch(() => null)
  if (!bitmap) return file
  const canvas = document.createElement('canvas')
  canvas.width = bitmap.width
  canvas.height = bitmap.height
  const ctx = canvas.getContext('2d')
  if (!ctx) return file
  ctx.fillStyle = '#ffffff'
  ctx.fillRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(bitmap, 0, 0)
  bitmap.close()
  return (await new Promise<Blob | null>((resolve) => canvas.toBlob(resolve, 'image/jpeg', 0.92))) ?? file
}

const readAsDataUrl = (blob: Blob) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(blob)
    // oxlint-disable-next-line prefer-add-event-listener
    reader.onload = () => resolve(reader.result as string)
    // oxlint-disable-next-line prefer-add-event-listener
    reader.onerror = reject
  })

export const fileToBase64 = async (file: File | undefined): Promise<string | undefined> =>
  file instanceof File ? readAsDataUrl(await webpAsJpeg(file)) : undefined
